import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

const WIZARD_QUESTIONS_QUERY_KEY = "onboarding:wizard-questions";

export default function useWizardQuestionsQuery() {
    return useQuery({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: [WIZARD_QUESTIONS_QUERY_KEY],
        queryFn() {
            return salesApiService.onboarding.fetchOnboardingDescription();
        },
    });
}
